interface IFormComputed{
    value: string
    label: string
}

export default function FormComputed({value, label}: IFormComputed) {
    return (
        <div className="form-computed__wrapper">
            <p className="small margin__bottom--xxs">{label}</p>
            <div className="form-computed__value-wrapper">
                <p className="small">{value}</p>
            </div>
        </div>
    )
}